function segVarPop(obj) {
    if (typeof PageMetadata != 'undefined' && typeof PageMetadata.pageSegVars != 'undefined') {
        if (PageMetadata.pageSegVars.art != "0") {
            obj.activityId = Number(PageMetadata.pageSegVars.art);
        }
        if (PageMetadata.pageSegVars.ssp != "0") {
            obj.leadSpec = Number(PageMetadata.pageSegVars.ssp);
        }
        if (PageMetadata.pageSegVars.as != "0") {
            if (typeof PageMetadata.pageSegVars.as === 'string') {
                obj.allSpecialties = $.map(PageMetadata.pageSegVars.as.split(','), function (obj) {
                    return Number(obj);
                });
            } else {
                obj.allSpecialties = PageMetadata.pageSegVars.as
            }
        }
        if (PageMetadata.pageSegVars.scg != "0") {
            obj.leadConcept = Number(PageMetadata.pageSegVars.scg);
        }
        if (PageMetadata.pageSegVars.ac != "0") {
            if (typeof PageMetadata.pageSegVars.ac === 'string') {
                obj.allConcepts = $.map(PageMetadata.pageSegVars.ac.split(','), function (obj) {
                    return Number(obj);
                });
            } else {
                obj.allConcepts = PageMetadata.pageSegVars.ac
            }
        }
        if (PageMetadata.pageSegVars.cg != "0") {
            obj.contentGroup = Number(PageMetadata.pageSegVars.cg);
        }
        if (PageMetadata.exclusionCategories.length > 0) {
            obj.blockCode = PageMetadata.exclusionCategories;
        }
    }
}

const cpArticleLoad = window.cpArticleLoad || function cpArticleLoad(appname) {
    var cpArticle = {};
    var testPagination;
    segVarPop(cpArticle);
    cpArticle.appname = appname;
    cpArticle.activityName = "view";
    if (cpArticle.appname === "viewarticle") {
        testPagination = window.location.pathname.match(/\/viewarticle\/\d+_\d+/);
        if (testPagination !== null) {
            cpArticle.pageN = window.location.pathname.match(/\/viewarticle\/\d+_\d+/)[0].split('_')[1];
        } else {
            cpArticle.pageN = 1;
        }
    }
	else if (cpArticle.appname === "drug" && typeof CURRENT_DRUG_ID !== 'undefined') {
		cpArticle.activityId = Number(CURRENT_DRUG_ID.trim());
	}
    postCp(cpArticle);
}

export { cpArticleLoad }